import { SupportedLocale, TranslationSchema } from './types';

export const TRANSLATIONS: Record<SupportedLocale, TranslationSchema> = {
  ja: {
    app: {
      title: 'Jiggly Touch (ジグリータッチ)',
      subtitle: '触れるぷるぷる画像アプリ',
      privacyBadge: '🛡️ 画像は端末内でのみ安全に処理されます（外部送信なし）',
    },
    sim: {
      label: '🔧 [エディション・シミュレーター]',
      webFree: '🌐 Web無料版',
      pcPaid: '💻 PCアプリ有料版',
      mobilePaid: '📱 モバイルアプリ有料版',
    },
    header: {
      openFile: '📂 画像を開く',
      openUrl: '🌐 URLから開く',
      openUrlLocked: '🔒 URLから開く (有料)',
      presets: '🔖 プリセット',
      export: '🎥 エクスポート',
      exportLocked: '🔒 エクスポート (有料)',
      share: '𝕏 シェア',
      togglePanel: '設定パネル切替',
      mobileOpen: '⚙️ 設定を開く',
      mobileClose: '✕ 設定を閉じる',
      langSelect: '言語切替',
      proBadge: '👑 Pro',
      getProBtn: '👑 Pro版を購入',
    },
    canvas: {
      hint: '👆 画像の好きなところをつまんで引っ張ってみてね！',
      sampleLabel: 'サンプル:',
      dropOverlay: 'ここに画像をドロップして読み込み',
      watermark: '🍮 Jiggly Touch',
      pinTitle: '揺れる位置（ドラッグして移動可能）',
      samplePudding: 'プリン',
      samplePeach: 'ピーチ',
      sampleCherry: 'チェリー',
      sampleNikukyu: '肉球',
      sampleGirl: '女の子',
      guideLink: '📖 使い方・FAQ',
    },
    physics: {
      tabTitle: '🎛 ぷるぷる物理',
      radius: '影響範囲',
      stiffness: '弾力（復元力）',
      damping: '余韻（揺れの持続）',
      touchRing: 'クリック/タッチ位置を〇で強調',
      poke: '👉 ポンと突く',
      reset: '↺ 標準に戻す',
      savePreset: '💾 プリセットとして保存',
      savePresetLocked: '🔒 プリセット保存 (有料版限定)',
    },
    wobble: {
      tabTitle: '💓 自動揺れ',
      enable: '自動揺れを有効化',
      mode: '揺れモード',
      breath: '🌬️ 呼吸',
      heartbeat: '💓 心拍',
      tremble: '⚡ 微振動',
      speed: '揺れの速さ',
      intensity: '揺れの強さ',
      radius: '揺れの範囲',
      origin: '揺らす位置・ガイド',
      showGuide: '👁 ガイドを表示',
      hideGuide: '✓ ガイドを隠す',
      pickPos: '📍 クリック指定',
      pickingPos: '👆 画面をクリック...',
      resetCenter: '↺ 中央',
      centerLabel: '中央',
      guideNote: '※ 自動揺れ再生中は画面を遮らないようピンは自動非表示になります。「ガイドを表示」を押すとピンと範囲サークルが現れ、直接ドラッグして調整できます。',
    },
    audio: {
      tabTitle: '🔊 サウンド',
      masterVolume: 'マスター音量',
      seSelect: '効果音の選択',
      sePurin: '🍮 ぷるん (標準)',
      sePoyon: '🎈 ぽよん (弾力)',
      seWater: '💧 ぽちゃん (水滴)',
      mute: 'ミュート (消音)',
    },
    urlModal: {
      title: 'Web画像のURLから読み込み',
      desc: 'Web上にある画像のURLを指定して、キャンバスに直接取り込みます。',
      proNote: '（※ アプリ有料版限定機能）',
      inputLabel: '画像URL',
      placeholder: 'https://example.com/image.png',
      samplesTitle: '💡 テスト用サンプルURL（クリックで入力）:',
      sampleCat: '🐱 子猫',
      sampleSweet: '🍓 いちごスイーツ',
      sampleSakura: '🌸 桜',
      note: '※ 直接アクセス可能な画像URL（JPG, PNG, WebP, SVG または data:image/...）に対応しています。',
      submit: '📥 画像を読み込む',
      loading: '⏳ 読み込み中...',
      cancel: 'キャンセル',
      errEmpty: '画像URLを入力してください。',
      errInvalid: '有効なURL（http://, https://, または data:image/...）を入力してください。',
      errFailed: '画像の読み込みに失敗しました。外部サイトのアクセス制限(CORS)により保護されている可能性があります。画像を右クリックして「画像をコピー」し、画面上で Ctrl+V (ペースト) すると直接読み込めます！',
      tipPaste: '💡 DMM、X、Pixivなどの保護された画像は、画像を右クリックして「画像をコピー」し、画面上で Ctrl+V（貼り付け）を押すと一瞬で直接取り込めます！',
    },
    export: {
      title: '動画・アニメーションの書き出し',
      format: '1. 出力フォーマット',
      fmtGif: 'GIFアニメ',
      fmtMp4: 'MP4動画',
      fmtWebm: 'WebM動画',
      duration: '2. 録画時間',
      start: '🔴 録画を開始して書き出し',
      recording: '⏺ 録画中...',
      processing: '⚙️ エンコード中...',
      watermarkNotice: '※ Web無料版ではウォーターマーク（透かしロゴ）が入ります。アプリ有料版で透かしなし高画質出力が可能です。',
      cancel: 'キャンセル',
      freeNotice: '※ Web無料版では右下に可愛い透かしロゴ「🍮 Jiggly Touch」が入ります。SNSシェア大歓迎！',
      proNotice: '👑 Pro版有効：透かしロゴなし（完全除去）で高画質保存されます。',
      viewProBtn: '👑 Pro版を見る',
      completeTitle: '書き出し完了！🎉',
      completeSaved: 'ダウンロードしました！できたアニメーションを 𝕏 でシェアしよう！',
      shareToX: '𝕏 (Twitter) でシェア',
      copyShareText: '📋 投稿文をコピー',
      copiedText: '投稿文をクリップボードにコピーしました！',
      downloadAgain: '📥 再ダウンロード',
      tipXShare: '💡 ボタンを押すと𝕏の投稿画面が開きます。先ほど保存されたGIF/動画をドラッグ＆ドロップして添付してね！',
      proUpsellTitle: '✨ 透かしロゴを消したいですか？',
      proUpsellDesc: 'Pro版なら透かしなし完全保存・自動揺れ・可愛い触覚効果音 ($1.99)',
      newExport: 'もう一度書き出す',
      close: '閉じる',
      recTimer: 'REC',
      touchHint: '画面をタッチして揺らしてください！',
    },
    preset: {
      saveTitle: '現在の設定をプリセット保存',
      manageTitle: 'プリセット管理',
      nameLabel: 'プリセット名',
      saveBtn: '💾 保存する',
      applyBtn: '適用',
      deleteBtn: '削除',
      cancelBtn: 'キャンセル',
      defaultName: 'プリン(標準)',
      maxLimitNotice: '保存件数が上限に達しています。',
    },
    upgrade: {
      title: 'アプリ版（有料）限定機能',
      heading: 'アプリ有料版でさらに快適に！',
      perkUrl: '・Web上の画像URLを直接指定して取り込み',
      perkPreset: '・無制限のプリセット保存',
      perkExport: '・動画・GIFの高画質・透かしなしエクスポート',
      perkAudio: '・触った時の可愛いリアクション効果音＆ボイス再生',
      perkWobble: '・生きているかのような自律自動揺れモード',
      hint: '💡 画面上部のシミュレーターバーで「📱 アプリ有料版」を選択すると、今すぐ全機能を体験できます！',
      ok: 'OK（理解した）',
      buyBtn: '👑 Gumroad で Pro版を購入する（セール中 $1.99 / 定価 $2.99）',
      saleBadge: '🔥 リリース記念 33% OFF セール中',
      haveKey: 'すでにご購入済みの方（ライセンスキー入力）：',
      keyPlaceholder: 'ライセンスキーを貼り付け（例: XXXXXXXX-XXXXXXXX-...）',
      activateBtn: 'ライセンスを有効化',
      activating: '認証中...',
      successMsg: '🎉 Pro版が有効化されました！全機能が解放されました。',
      deactivateBtn: 'この端末のライセンスを解除',
      deactivatedMsg: 'ライセンスを解除しました。無料版に戻りました。',
      activeStatus: '👑 Pro版 有効化済み',
      errInvalid: '無効なライセンスキーです。キーをご確認ください。',
      errMaxUses: 'このキーの利用上限端末数に達しています。',
      errNetwork: '通信エラーが発生しました。インターネット接続をご確認ください。',
      errRefunded: 'このライセンスは返金またはキャンセルされています。',
      closeBtn: '閉じる',
    },
    share: {
      btnLabel: '𝕏 シェア',
      modalTitle: '𝕏 (Twitter) でシェア',
      modalDesc: 'ぷるぷる揺れる体験を 𝕏 (Twitter) に投稿して友達に共有しよう！',
      tweetText: '「Jiggly Touch」で画像をぷるぷる揺らしてみたよ！🍮✨ 触れる画像を作って遊ぼう：',
      hashtags: 'JigglyTouch,ジグリータッチ',
      postBtn: '𝕏 に投稿する',
      copyBtn: '🔗 リンクをコピー',
      copiedNotice: 'リンクをクリップボードにコピーしました！',
      exportSuccessTitle: 'アニメーションの書き出し完了！🎉',
      exportSuccessDesc: 'ファイルの保存が完了しました。できたアニメーションを 𝕏 (Twitter) でシェアしよう！',
      closeBtn: '閉じる',
    },
    ad: {
      sponsored: 'スポンサー',
      houseAdText: '🍮 Jiggly Touch Pro: 広告なし＆全機能解放（🔥 リリース記念 33% OFF セール $1.99）',
      removeAdsBtn: '👑 広告を消す',
    },
    legal: {
      privacyTitle: 'プライバシーポリシー',
      termsTitle: '利用規約',
      contactTitle: 'お問い合わせ窓口',
      footerPrivacy: 'プライバシーポリシー',
      footerTerms: '利用規約',
      footerContact: 'お問い合わせ: 𝕏 @KILROYSANWHERE',
      contactDesc: 'ご質問、不具合報告、機能要望等は 𝕏 (旧Twitter) の公式アカウントへお気軽にDMまたはメンションにてご連絡ください。',
      xAccount: '@KILROYSANWHERE',
      closeBtn: '閉じる',
      openFullPrivacy: '↗ プライバシーポリシー全文を新しいタブで開く',
      openFullTerms: '↗ 利用規約全文を新しいタブで開く',
      privacyBanner: '<strong>🛡️ 画像のプライバシー保護について:</strong><br>読み込んだ画像はすべてご利用中のブラウザ内（ローカル環境）でのみ安全に物理シミュレーション処理されます。当サービスのサーバーにアップロード・保存・共有されることは一切ありません。',
      privacySec1Title: '1. 広告配信（Google AdSense 等）',
      privacySec1Desc: '当サイトでは、第三者配信事業者（Google AdSense 等）による広告サービスを利用または予定しています。これらの事業者は、ユーザーの興味に応じた商品やサービスの広告を表示するため、Cookie（クッキー）を使用することがあります。<br>Cookie を無効にする設定および詳細は <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noopener noreferrer" style="color: var(--color-primary); text-decoration: underline;">Google の広告ポリシー</a>、または <a href="https://www.aboutads.info" target="_blank" rel="noopener noreferrer" style="color: var(--color-primary); text-decoration: underline;">aboutads.info</a> をご参照ください。',
      privacySec2Title: '2. 有料ライセンス決済（Gumroad）',
      privacySec2Desc: 'Pro版の購入決済は外部プラットフォーム「Gumroad」を通じて安全に行われます。当サイトがクレジットカード番号等の機微情報を取得・保持することはありません。',
      termsSec1Title: '1. ライセンスとエディション',
      termsSec1Desc: '・無料版: 個人利用においてどなたでもご利用いただけます。<br>・Pro版: 買い切りライセンスをご購入いただくことで、最大2台の端末まで全機能をご利用いただけます。',
      termsSec2Title: '2. 著作権およびコンテンツ責任',
      termsSec2Desc: '読み込んだ画像の著作権は各権利者に帰属します。ユーザーが本サービスを通じて作成・エクスポートしたコンテンツの権利関係および利用に関しては、ユーザー自身が一切の責任を負うものとします。',
      termsSec3Title: '3. 禁止事項',
      termsSec3Desc: '公序良俗に反する行為、第三者の権利侵害、ライセンスキーの不正再配布・転売を固く禁じます。',
      contactButton: '𝕏 @KILROYSANWHERE に問い合わせる',
      operatorLabel: '運営者: <strong>KILROYSAN</strong>',
    },
  },

  en: {
    app: {
      title: 'Jiggly Touch',
      subtitle: 'Interactive Wobbling Image App',
      privacyBadge: '🛡️ Images are processed locally on your device (Never uploaded to any server)',
    },
    sim: {
      label: '🔧 [Edition Simulator]',
      webFree: '🌐 Web Free',
      pcPaid: '💻 PC App Paid',
      mobilePaid: '📱 Mobile App Paid',
    },
    header: {
      openFile: '📂 Open Image',
      openUrl: '🌐 Open from URL',
      openUrlLocked: '🔒 Open from URL (Pro)',
      presets: '🔖 Presets',
      export: '🎥 Export',
      exportLocked: '🔒 Export (Pro)',
      share: '𝕏 Share',
      togglePanel: 'Toggle Settings Panel',
      mobileOpen: '⚙️ Settings',
      mobileClose: '✕ Close Settings',
      langSelect: 'Language',
      proBadge: '👑 Pro',
      getProBtn: '👑 Get Pro',
    },
    canvas: {
      hint: '👆 Pinch and drag anywhere on the image to stretch!',
      sampleLabel: 'Samples:',
      dropOverlay: 'Drop image here to load',
      watermark: '🍮 Jiggly Touch',
      pinTitle: 'Wobble origin (Draggable)',
      samplePudding: 'Pudding',
      samplePeach: 'Peach',
      sampleCherry: 'Cherry',
      sampleNikukyu: 'Cat Paw',
      sampleGirl: 'Anime Girl',
      guideLink: '📖 Guide & FAQ',
    },
    physics: {
      tabTitle: '🎛 Physics',
      radius: 'Radius of Effect',
      stiffness: 'Elasticity (Bounce)',
      damping: 'Resonance (Duration)',
      touchRing: 'Highlight touch point with circle',
      poke: '👉 Poke Image',
      reset: '↺ Reset Default',
      savePreset: '💾 Save as Preset',
      savePresetLocked: '🔒 Save Preset (Pro Only)',
    },
    wobble: {
      tabTitle: '💓 Auto Wobble',
      enable: 'Enable Auto Wobble',
      mode: 'Wobble Pattern',
      breath: '🌬️ Breath',
      heartbeat: '💓 Heartbeat',
      tremble: '⚡ Tremble',
      speed: 'Wobble Speed',
      intensity: 'Wobble Intensity',
      radius: 'Wobble Area',
      origin: 'Wobble Origin & Guide',
      showGuide: '👁 Show Guide',
      hideGuide: '✓ Hide Guide',
      pickPos: '📍 Pick by Click',
      pickingPos: '👆 Click canvas...',
      resetCenter: '↺ Center',
      centerLabel: 'Center',
      guideNote: 'Note: The pin and range circle are automatically hidden during playback so as not to obscure the image. Click "Show Guide" to adjust origin and range.',
    },
    audio: {
      tabTitle: '🔊 Sound',
      masterVolume: 'Master Volume',
      seSelect: 'Sound Effect',
      sePurin: '🍮 Purin (Standard)',
      sePoyon: '🎈 Poyon (Bouncy)',
      seWater: '💧 Plop (Water Drop)',
      mute: 'Mute Audio',
    },
    urlModal: {
      title: 'Import Image from Web URL',
      desc: 'Enter an image URL from the web to load it directly onto the canvas.',
      proNote: '(※ Pro Edition Only)',
      inputLabel: 'Image URL',
      placeholder: 'https://example.com/image.png',
      samplesTitle: '💡 Quick Test Samples (Click to insert):',
      sampleCat: '🐱 Kitten',
      sampleSweet: '🍓 Strawberry Cake',
      sampleSakura: '🌸 Cherry Blossom',
      note: '※ Supports directly accessible image URLs (JPG, PNG, WebP, SVG or data:image/...).',
      submit: '📥 Load Image',
      loading: '⏳ Loading...',
      cancel: 'Cancel',
      errEmpty: 'Please enter an image URL.',
      errInvalid: 'Please enter a valid URL (http://, https://, or data:image/...).',
      errFailed: 'Failed to load image. The image may be protected by cross-origin access restrictions (CORS). You can copy the image directly and press Ctrl+V on the screen to load it!',
      tipPaste: '💡 For protected images (X, Pixiv, DMM, etc.), right-click the image and select "Copy image", then press Ctrl+V on the screen to load it instantly!',
    },
    export: {
      title: 'Export Animation & Video',
      format: '1. Output Format',
      fmtGif: 'Animated GIF',
      fmtMp4: 'MP4 Video',
      fmtWebm: 'WebM Video',
      duration: '2. Duration',
      start: '🔴 Start Recording & Export',
      recording: '⏺ Recording...',
      processing: '⚙️ Encoding...',
      watermarkNotice: '※ Web Free edition includes a watermark logo. The Pro edition exports high-quality, watermark-free media.',
      cancel: 'Cancel',
      freeNotice: '※ Free edition includes a cute watermark logo in the bottom-right corner. Feel free to share on SNS!',
      proNotice: '👑 Pro Active: Exports in high-quality without watermarks.',
      viewProBtn: '👑 Get Pro',
      completeTitle: 'Export Completed! 🎉',
      completeSaved: 'Downloaded! Share your squishy animation on 𝕏 (Twitter)!',
      shareToX: 'Share to 𝕏',
      copyShareText: '📋 Copy Tweet Text',
      copiedText: 'Tweet text copied to clipboard!',
      downloadAgain: '📥 Download Again',
      tipXShare: '💡 Clicking the button opens 𝕏! Simply drag & drop your downloaded video/GIF to attach.',
      proUpsellTitle: '✨ Want to remove the watermark?',
      proUpsellDesc: 'Pro edition offers 100% watermark-free export, living auto-wobble & cute sound effects ($1.99)',
      newExport: 'Create Another',
      close: 'Close',
      recTimer: 'REC',
      touchHint: 'Touch & drag to wobble!',
    },
    preset: {
      saveTitle: 'Save Current Settings as Preset',
      manageTitle: 'Manage Presets',
      nameLabel: 'Preset Name',
      saveBtn: '💾 Save',
      applyBtn: 'Apply',
      deleteBtn: 'Delete',
      cancelBtn: 'Cancel',
      defaultName: 'Pudding (Standard)',
      maxLimitNotice: 'Maximum preset limit reached.',
    },
    upgrade: {
      title: 'Pro Edition Feature',
      heading: 'Get the Full Experience with Pro Edition!',
      perkUrl: '・Import images directly from Web URLs',
      perkPreset: '・Unlimited preset saving and management',
      perkExport: '・High-definition, watermark-free GIF & Video export',
      perkAudio: '・Play cute reaction sound effects and voice clips on touch',
      perkWobble: '・Autonomous living wobble modes (Breath, Heartbeat, Tremble)',
      hint: '💡 Select "📱 Mobile App Paid" or "💻 PC App Paid" in the simulator bar above to try all features now!',
      ok: 'Got it',
      buyBtn: '👑 Buy Pro on Gumroad ($1.99 Launch Sale / Reg. $2.99)',
      saleBadge: '🔥 SPECIAL LAUNCH SALE 33% OFF',
      haveKey: 'Already purchased? Enter your license key:',
      keyPlaceholder: 'Paste license key (e.g. XXXXXXXX-XXXXXXXX-...)',
      activateBtn: 'Activate Pro',
      activating: 'Verifying...',
      successMsg: '🎉 Pro Edition activated! All features unlocked.',
      deactivateBtn: 'Deactivate this device',
      deactivatedMsg: 'License deactivated. Switched back to Free edition.',
      activeStatus: '👑 Pro Edition Active',
      errInvalid: 'Invalid license key. Please check and try again.',
      errMaxUses: 'Maximum device limit reached for this license.',
      errNetwork: 'Network error. Could not connect to Gumroad API.',
      errRefunded: 'This license has been refunded or cancelled.',
      closeBtn: 'Close',
    },
    share: {
      btnLabel: '𝕏 Share',
      modalTitle: 'Share on 𝕏 (Twitter)',
      modalDesc: 'Share your jiggly wobbling creations on 𝕏 (Twitter) with friends!',
      tweetText: 'I made a jiggly tactile animation with Jiggly Touch! 🍮✨ Try wobbling your favorite images:',
      hashtags: 'JigglyTouch,InteractiveArt',
      postBtn: 'Post on 𝕏',
      copyBtn: '🔗 Copy Link',
      copiedNotice: 'Link copied to clipboard!',
      exportSuccessTitle: 'Animation Export Complete! 🎉',
      exportSuccessDesc: 'Your file is ready and saved. Share your awesome jiggly creation on 𝕏 (Twitter)!',
      closeBtn: 'Close',
    },
    ad: {
      sponsored: 'SPONSORED',
      houseAdText: '🍮 Jiggly Touch Pro: Ad-Free & All Features Unlocked (🔥 33% OFF Sale $1.99)',
      removeAdsBtn: '👑 Remove Ads',
    },
    legal: {
      privacyTitle: 'Privacy Policy',
      termsTitle: 'Terms of Service',
      contactTitle: 'Contact Us',
      footerPrivacy: 'Privacy Policy',
      footerTerms: 'Terms of Service',
      footerContact: 'Contact: 𝕏 @KILROYSANWHERE',
      contactDesc: 'For questions, feedback, or support, feel free to reach out via direct message or mention on 𝕏 (Twitter).',
      xAccount: '@KILROYSANWHERE',
      closeBtn: 'Close',
      openFullPrivacy: '↗ View Full Privacy Policy in New Tab',
      openFullTerms: '↗ View Full Terms of Service in New Tab',
      privacyBanner: '<strong>🛡️ Zero Server Image Storage:</strong><br>All images loaded into Jiggly Touch are processed 100% locally in your web browser. Images are never uploaded, stored, or transmitted to any remote servers.',
      privacySec1Title: '1. Advertising (Google AdSense)',
      privacySec1Desc: 'This website uses third-party advertising services (e.g. Google AdSense). These vendors may use cookies to serve ads based on prior visits.<br>To opt out of personalized ads, visit <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noopener noreferrer" style="color: var(--color-primary); text-decoration: underline;">Google Ad Settings</a> or <a href="https://www.aboutads.info" target="_blank" rel="noopener noreferrer" style="color: var(--color-primary); text-decoration: underline;">aboutads.info</a>.',
      privacySec2Title: '2. Paid Purchases & Payments (Gumroad)',
      privacySec2Desc: 'Pro license transactions are handled securely through Gumroad. We never collect or store your payment credentials directly.',
      termsSec1Title: '1. License & Editions',
      termsSec1Desc: '・Free Edition: Free to use for personal purposes.<br>・Pro Edition: Lifetime access valid on up to 2 devices owned by the purchaser.',
      termsSec2Title: '2. Intellectual Property & User Content',
      termsSec2Desc: 'You retain full ownership of the images you import. You are solely responsible for ensuring you have rights to any exported creations or animations.',
      termsSec3Title: '3. Prohibitions',
      termsSec3Desc: 'Unlawful activities, infringing intellectual property, or unauthorized redistribution/resale of Pro license keys is strictly prohibited.',
      contactButton: 'Contact @KILROYSANWHERE on 𝕏',
      operatorLabel: 'Operator: <strong>KILROYSAN</strong>',
    },
  },

  'zh-TW': {
    app: {
      title: 'Jiggly Touch',
      subtitle: '可互動圖片晃動應用',
      privacyBadge: '🛡️ 圖片僅在設備本地安全處理（絕不會上傳至任何伺服器）',
    },
    sim: {
      label: '🔧 [版本模擬器]',
      webFree: '🌐 Web免費版',
      pcPaid: '💻 PC付費版',
      mobilePaid: '📱 手機付費版',
    },
    header: {
      openFile: '📂 開啟圖片',
      openUrl: '🌐 從URL開啟',
      openUrlLocked: '🔒 從URL開啟 (付費)',
      presets: '🔖 預設設定',
      export: '🎥 匯出動畫',
      exportLocked: '🔒 匯出動畫 (付費)',
      share: '𝕏 分享',
      togglePanel: '切換設定面板',
      mobileOpen: '⚙️ 開啟設定',
      mobileClose: '✕ 關閉設定',
      langSelect: '語言切換',
      proBadge: '👑 Pro',
      getProBtn: '👑 購買 Pro 版',
    },
    canvas: {
      hint: '👆 捏住並拖曳圖片的任何位置來拉伸！',
      sampleLabel: '範例:',
      dropOverlay: '將圖片拖放至此處載入',
      watermark: '🍮 Jiggly Touch',
      pinTitle: '晃動起點（可拖曳移動）',
      samplePudding: '布丁',
      samplePeach: '水蜜桃',
      sampleCherry: '櫻桃',
      sampleNikukyu: '貓咪肉球',
    },
    physics: {
      tabTitle: '🎛 物理彈性',
      radius: '影響範圍',
      stiffness: '彈力（復原力）',
      damping: '餘韻（持續時間）',
      touchRing: '用圓圈標記觸控位置',
      poke: '👉 戳一下圖片',
      reset: '↺ 重設為預設值',
      savePreset: '💾 儲存為預設',
      savePresetLocked: '🔒 儲存預設 (付費限定)',
    },
    wobble: {
      tabTitle: '💓 自動晃動',
      enable: '啟用自動晃動',
      mode: '晃動模式',
      breath: '🌬️ 呼吸',
      heartbeat: '💓 心跳',
      tremble: '⚡ 微振動',
      speed: '晃動速度',
      intensity: '晃動強度',
      radius: '晃動範圍',
      origin: '晃動起點與導引',
      showGuide: '👁 顯示導引',
      hideGuide: '✓ 隱藏導引',
      pickPos: '📍 點擊指定',
      pickingPos: '👆 請點擊畫面...',
      resetCenter: '↺ 置中',
      centerLabel: '置中',
      guideNote: '※ 自動晃動播放期間，標記針與範圍圈會自動隱藏以免遮擋畫面。點擊「顯示導引」即可直接拖曳調整。',
    },
    audio: {
      tabTitle: '🔊 聲音音效',
      masterVolume: '主音量',
      seSelect: '音效選擇',
      sePurin: '🍮 Q彈 (標準)',
      sePoyon: '🎈 啵呦 (彈力)',
      seWater: '💧 撲通 (水滴)',
      mute: '靜音',
    },
    urlModal: {
      title: '從網頁URL載入圖片',
      desc: '輸入網頁上的圖片網址，直接載入到畫布中。',
      proNote: '（※ 專業付費版限定功能）',
      inputLabel: '圖片網址 (URL)',
      placeholder: 'https://example.com/image.png',
      samplesTitle: '💡 測試用範例網址（點擊填入）:',
      sampleCat: '🐱 小貓咪',
      sampleSweet: '🍓 草莓甜點',
      sampleSakura: '🌸 櫻花',
      note: '※ 支援可直接存取的圖片網址（JPG、PNG、WebP、SVG 或 data:image/...）。',
      submit: '📥 載入圖片',
      loading: '⏳ 載入中...',
      cancel: '取消',
      errEmpty: '請輸入圖片網址。',
      errInvalid: '請輸入有效的網址（http://、https:// 或 data:image/...）。',
      errFailed: '圖片載入失敗。請檢查網址是否正確，或是否允許跨域存取 (CORS)。',
    },
    export: {
      title: '匯出動畫與影片',
      format: '1. 輸出格式',
      fmtGif: 'GIF 動圖',
      fmtMp4: 'MP4 影片',
      fmtWebm: 'WebM 影片',
      duration: '2. 錄製時長',
      start: '🔴 開始錄製並匯出',
      recording: '⏺ 錄製中...',
      processing: '⚙️ 編碼處理中...',
      watermarkNotice: '※ Web免費版匯出時會包含浮水印。付費專業版可匯出高清無浮水印檔案。',
      cancel: '取消',
      freeNotice: '※ Web免費版右下角會包含可愛的浮水印標誌。歡迎分享至社群平台！',
      proNotice: '👑 Pro版已啟用：以高清無浮水印格式匯出。',
      viewProBtn: '👑 查看Pro版',
      completeTitle: '匯出完成！🎉',
      completeSaved: '已完成下載！快將Q彈動畫分享至 𝕏 吧！',
      shareToX: '在 𝕏 上分享',
      copyShareText: '📋 複製貼文內容',
      copiedText: '貼文內容已複製至剪貼簿！',
      downloadAgain: '📥 再次下載',
      tipXShare: '💡 點擊按鈕將開啟 𝕏 發文畫面。只需將已下載的影片/動圖拖曳至 𝕏 即可附加分享！',
      proUpsellTitle: '✨ 想去除浮水印嗎？',
      proUpsellDesc: 'Pro版提供100%無浮水印儲存、自律晃動與可愛觸覺音效 ($1.99)',
      newExport: '再製作一個',
      close: '關閉',
      recTimer: '錄製中',
      touchHint: '觸控螢幕使其搖晃！',
    },
    preset: {
      saveTitle: '儲存目前設定為預設',
      manageTitle: '管理預設設定',
      nameLabel: '預設名稱',
      saveBtn: '💾 儲存',
      applyBtn: '套用',
      deleteBtn: '刪除',
      cancelBtn: '取消',
      defaultName: '布丁 (標準)',
      maxLimitNotice: '已達預設儲存上限。',
    },
    upgrade: {
      title: '付費專業版限定功能',
      heading: '升級付費版，享受極致體驗！',
      perkUrl: '・直接指定網頁圖片URL載入',
      perkPreset: '・無限制儲存與管理預設設定',
      perkExport: '・匯出高清無浮水印的 GIF 動圖與影片',
      perkAudio: '・觸控時播放可愛反應音效與語音',
      perkWobble: '・如生命般栩栩如生的自主晃動模式',
      hint: '💡 在畫面上方的模擬器列切換至「📱 手機付費版」即可立即免費體驗全部功能！',
      ok: '確定（了解）',
      buyBtn: '👑 在 Gumroad 上購買 Pro 版（發售特惠 $1.99 / 原價 $2.99）',
      saleBadge: '🔥 發售特惠 33% OFF 限時特賣',
      haveKey: '已經購買？輸入您的授權金鑰：',
      keyPlaceholder: '貼上授權金鑰（例如：XXXXXXXX-XXXXXXXX-...）',
      activateBtn: '啟用 Pro 版',
      activating: '驗證中...',
      successMsg: '🎉 Pro 版已啟用！所有進階功能皆已解鎖。',
      deactivateBtn: '解除此裝置授權',
      deactivatedMsg: '已解除授權，切換回免費版。',
      activeStatus: '👑 Pro 版已啟用',
      errInvalid: '無效的授權金鑰，請確認後重試。',
      errMaxUses: '此金鑰已達裝置上限。',
      errNetwork: '網路錯誤，無法連接至 Gumroad 伺服器。',
      errRefunded: '此授權已被退款或取消。',
      closeBtn: '關閉',
    },
    share: {
      btnLabel: '𝕏 分享',
      modalTitle: '在 𝕏 (Twitter) 上分享',
      modalDesc: '將 Q 彈晃動的圖片體驗發佈至 𝕏 (Twitter) 與好友分享！',
      tweetText: '我用「Jiggly Touch」做出了 Q 彈晃動的圖片！🍮✨ 快來戳戳看你的推圖：',
      hashtags: 'JigglyTouch,Q彈觸控',
      postBtn: '發佈至 𝕏',
      copyBtn: '🔗 複製連結',
      copiedNotice: '連結已複製到剪貼簿！',
      exportSuccessTitle: '動畫匯出完成！🎉',
      exportSuccessDesc: '檔案已成功儲存。快把 Q 彈的晃動成果分享至 𝕏 (Twitter) 吧！',
      closeBtn: '關閉',
    },
    ad: {
      sponsored: '贊助商廣告',
      houseAdText: '🍮 Jiggly Touch Pro: 完全無廣告＆解鎖全部功能（🔥 限時 33% OFF $1.99）',
      removeAdsBtn: '👑 移除廣告',
    },
    legal: {
      privacyTitle: '隱私權政策',
      termsTitle: '服務條款',
      contactTitle: '聯絡我們',
      footerPrivacy: '隱私權政策',
      footerTerms: '服務條款',
      footerContact: '聯絡我們: 𝕏 @KILROYSANWHERE',
      contactDesc: '若有任何疑問、錯誤回報或功能建議，歡迎透過 𝕏 (Twitter) 私訊或標記聯絡我們。',
      xAccount: '@KILROYSANWHERE',
      closeBtn: '關閉',
    },
  },

  'zh-CN': {
    app: {
      title: 'Jiggly Touch',
      subtitle: '可互动图片晃动应用',
      privacyBadge: '🛡️ 图片仅在设备本地安全处理（绝不会上传至任何服务器）',
    },
    sim: {
      label: '🔧 [版本模拟器]',
      webFree: '🌐 Web免费版',
      pcPaid: '💻 PC付费版',
      mobilePaid: '📱 移动端付费版',
    },
    header: {
      openFile: '📂 打开图片',
      openUrl: '🌐 从URL打开',
      openUrlLocked: '🔒 从URL打开 (付费)',
      presets: '🔖 预设配置',
      export: '🎥 导出动画',
      exportLocked: '🔒 导出动画 (付费)',
      share: '𝕏 分享',
      togglePanel: '切换设置面板',
      mobileOpen: '⚙️ 打开设置',
      mobileClose: '✕ 关闭设置',
      langSelect: '语言切换',
      proBadge: '👑 Pro',
      getProBtn: '👑 购买 Pro 版',
    },
    canvas: {
      hint: '👆 捏住并拖拽图片的任何位置来拉伸！',
      sampleLabel: '范例:',
      dropOverlay: '将图片拖放至此处加载',
      watermark: '🍮 Jiggly Touch',
      pinTitle: '晃动起点（可拖拽移动）',
      samplePudding: '布丁',
      samplePeach: '水蜜桃',
      sampleCherry: '樱桃',
      sampleNikukyu: '猫咪肉球',
    },
    physics: {
      tabTitle: '🎛 物理弹性',
      radius: '影响范围',
      stiffness: '弹力（复原力）',
      damping: '余韵（持续时间）',
      touchRing: '用圆圈标记触控位置',
      poke: '👉 戳一下图片',
      reset: '↺ 重置为默认值',
      savePreset: '💾 保存为预设',
      savePresetLocked: '🔒 保存预设 (付费限定)',
    },
    wobble: {
      tabTitle: '💓 自动晃动',
      enable: '启用自动晃动',
      mode: '晃动模式',
      breath: '🌬️ 呼吸',
      heartbeat: '💓 心跳',
      tremble: '⚡ 微振动',
      speed: '晃动速度',
      intensity: '晃动强度',
      radius: '晃动范围',
      origin: '晃动起点与导向',
      showGuide: '👁 显示导向',
      hideGuide: '✓ 隐藏导向',
      pickPos: '📍 点击指定',
      pickingPos: '👆 请点击画面...',
      resetCenter: '↺ 居中',
      centerLabel: '居中',
      guideNote: '※ 自动晃动播放期间，标记针与范围圈会自动隐藏以免遮挡画面。点击“显示导向”即可直接拖拽调整。',
    },
    audio: {
      tabTitle: '🔊 声音音效',
      masterVolume: '主音量',
      seSelect: '音效选择',
      sePurin: '🍮 Q弹 (标准)',
      sePoyon: '🎈 啵呦 (弹性)',
      seWater: '💧 扑通 (水滴)',
      mute: '静音',
    },
    urlModal: {
      title: '从网页URL加载图片',
      desc: '输入网页上的图片网址，直接加载到画布中。',
      proNote: '（※ 专业付费版限定功能）',
      inputLabel: '图片网址 (URL)',
      placeholder: 'https://example.com/image.png',
      samplesTitle: '💡 测试用样例网址（点击填入）:',
      sampleCat: '🐱 小猫咪',
      sampleSweet: '🍓 草莓甜点',
      sampleSakura: '🌸 樱花',
      note: '※ 支持可直接访问的图片网址（JPG、PNG、WebP、SVG 或 data:image/...）。',
      submit: '📥 加载图片',
      loading: '⏳ 加载中...',
      cancel: '取消',
      errEmpty: '请输入图片网址。',
      errInvalid: '请输入有效的网址（http://、https:// 或 data:image/...）。',
      errFailed: '图片加载失败。请检查网址是否正确，或是否允许跨域访问 (CORS)。',
    },
    export: {
      title: '导出动画与视频',
      format: '1. 输出格式',
      fmtGif: 'GIF 动图',
      fmtMp4: 'MP4 视频',
      fmtWebm: 'WebM 视频',
      duration: '2. 录制时长',
      start: '🔴 开始录制并导出',
      recording: '⏺ 录制中...',
      processing: '⚙️ 编码处理中...',
      watermarkNotice: '※ Web免费版导出时包含水印。付费专业版可导出高清无水印文件。',
      cancel: '取消',
      freeNotice: '※ Web免费版右下角包含可爱水印标志。欢迎分享至社交平台！',
      proNotice: '👑 Pro版已启用：以高清无水印格式导出。',
      viewProBtn: '👑 查看Pro版',
      completeTitle: '导出完成！🎉',
      completeSaved: '已完成下载！快把Q弹动画分享到 𝕏 吧！',
      shareToX: '在 𝕏 上分享',
      copyShareText: '📋 复制推文内容',
      copiedText: '推文内容已复制到剪贴板！',
      downloadAgain: '📥 重新下载',
      tipXShare: '💡 点击按钮将打开 𝕏 发帖界面。只需将已下载的视频/动图拖拽至 𝕏 即可附加分享！',
      proUpsellTitle: '✨ 想要去除水印吗？',
      proUpsellDesc: 'Pro版提供100%无水印保存、自律晃动与可爱触觉音效 ($1.99)',
      newExport: '再制作一个',
      close: '关闭',
      recTimer: '录制中',
      touchHint: '触摸屏幕使其晃动！',
    },
    preset: {
      saveTitle: '保存当前设置为预设',
      manageTitle: '管理预设配置',
      nameLabel: '预设名称',
      saveBtn: '💾 保存',
      applyBtn: '应用',
      deleteBtn: '删除',
      cancelBtn: '取消',
      defaultName: '布丁 (标准)',
      maxLimitNotice: '已达到预设保存上限。',
    },
    upgrade: {
      title: '付费专业版限定功能',
      heading: '升级付费版，享受极致体验！',
      perkUrl: '・直接指定网页图片URL加载',
      perkPreset: '・无限制保存与管理预设配置',
      perkExport: '・导出高清无水印的 GIF 动图与视频',
      perkAudio: '・触控时播放可爱反应音效与语音',
      perkWobble: '・宛若生命般栩栩如生的自主晃动模式',
      hint: '💡 在页面上方的模拟器栏切换至“📱 移动端付费版”即可立即免费体验全部功能！',
      ok: '确定（了解）',
      buyBtn: '👑 在 Gumroad 上购买 Pro 版（首发特惠 $1.99 / 原价 $2.99）',
      saleBadge: '🔥 首发特惠 33% OFF 限时特卖',
      haveKey: '已经购买？输入您的授权密钥：',
      keyPlaceholder: '粘贴授权密钥（例如：XXXXXXXX-XXXXXXXX-...）',
      activateBtn: '激活 Pro 版',
      activating: '验证中...',
      successMsg: '🎉 Pro 版已激活！所有高级功能皆已解锁。',
      deactivateBtn: '解除此设备授权',
      deactivatedMsg: '已解除授权，切换回免费版。',
      activeStatus: '👑 Pro 版已激活',
      errInvalid: '无效的授权密钥，请确认后重试。',
      errMaxUses: '此密钥已达设备上限。',
      errNetwork: '网络错误，无法连接至 Gumroad 服务器。',
      errRefunded: '此授权已被退款或取消。',
      closeBtn: '关闭',
    },
    share: {
      btnLabel: '𝕏 分享',
      modalTitle: '在 𝕏 (Twitter) 上分享',
      modalDesc: '将 Q 弹晃动的图片体验发布到 𝕏 (Twitter) 和好友分享！',
      tweetText: '我用「Jiggly Touch」制作了 Q 弹晃动的图片！🍮✨ 来揉揉你的自选图片吧：',
      hashtags: 'JigglyTouch,果冻触控',
      postBtn: '发布到 𝕏',
      copyBtn: '🔗 复制链接',
      copiedNotice: '链接已复制到剪贴板！',
      exportSuccessTitle: '动画导出完成！🎉',
      exportSuccessDesc: '文件已成功保存。快把 Q 弹晃动的成果分享至 𝕏 (Twitter) 吧！',
      closeBtn: '关闭',
    },
    ad: {
      sponsored: '赞助商广告',
      houseAdText: '🍮 Jiggly Touch Pro: 完全无广告＆解锁全部功能（🔥 限时 33% OFF $1.99）',
      removeAdsBtn: '👑 移除广告',
    },
    legal: {
      privacyTitle: '隐私政策',
      termsTitle: '服务条款',
      contactTitle: '联系我们',
      footerPrivacy: '隐私政策',
      footerTerms: '服务条款',
      footerContact: '联系我们: 𝕏 @KILROYSANWHERE',
      contactDesc: '如有任何问题、Bug 反馈或功能建议，欢迎通过 𝕏 (Twitter) 私信或艾特联系我们。',
      xAccount: '@KILROYSANWHERE',
      closeBtn: '关闭',
    },
  },

  ko: {
    app: {
      title: 'Jiggly Touch',
      subtitle: '만지는 이미지 흔들림 앱',
      privacyBadge: '🛡️ 이미지는 기기 내부에서만 안전하게 처리됩니다 (외부 서버 전송 없음)',
    },
    sim: {
      label: '🔧 [에디션 시뮬레이터]',
      webFree: '🌐 Web 무료 버전',
      pcPaid: '💻 PC 앱 유료 버전',
      mobilePaid: '📱 모바일 앱 유료 버전',
    },
    header: {
      openFile: '📂 이미지 열기',
      openUrl: '🌐 URL에서 열기',
      openUrlLocked: '🔒 URL에서 열기 (유료)',
      presets: '🔖 프리셋',
      export: '🎥 내보내기',
      exportLocked: '🔒 내보내기 (유료)',
      share: '𝕏 공유',
      togglePanel: '설정 패널 전환',
      mobileOpen: '⚙️ 설정 열기',
      mobileClose: '✕ 설정 닫기',
      langSelect: '언어 변경',
      proBadge: '👑 Pro',
      getProBtn: '👑 Pro 구매',
    },
    canvas: {
      hint: '👆 이미지의 원하는 곳을 잡고 당겨보세요!',
      sampleLabel: '샘플:',
      dropOverlay: '여기에 이미지를 드롭하여 로드',
      watermark: '🍮 Jiggly Touch',
      pinTitle: '흔들림 중심점 (드래그하여 이동 가능)',
      samplePudding: '푸딩',
      samplePeach: '복숭아',
      sampleCherry: '체리',
      sampleNikukyu: '고양이 젤리 (육구)',
    },
    physics: {
      tabTitle: '🎛 물리 역학',
      radius: '영향 범위',
      stiffness: '탄력 (복원력)',
      damping: '여운 (지속 시간)',
      touchRing: '클릭/터치 위치 원형 강조',
      poke: '👉 콕 찌르기',
      reset: '↺ 기본값으로 리셋',
      savePreset: '💾 프리셋으로 저장',
      savePresetLocked: '🔒 프리셋 저장 (유료 한정)',
    },
    wobble: {
      tabTitle: '💓 자동 흔들림',
      enable: '자동 흔들림 활성화',
      mode: '흔들림 모드',
      breath: '🌬️ 호흡',
      heartbeat: '💓 심장 박동',
      tremble: '⚡ 미세 진동',
      speed: '흔들림 속도',
      intensity: '흔들림 강도',
      radius: '흔들림 범위',
      origin: '흔들림 위치 및 가이드',
      showGuide: '👁 가이드 표시',
      hideGuide: '✓ 가이드 숨기기',
      pickPos: '📍 클릭 지정',
      pickingPos: '👆 화면을 클릭...',
      resetCenter: '↺ 중앙',
      centerLabel: '중앙',
      guideNote: '※ 자동 흔들림 재생 중에는 화면 감상을 방해하지 않도록 핀과 범위가 자동으로 숨겨집니다. "가이드 표시"를 누르면 드래그하여 조정할 수 있습니다.',
    },
    audio: {
      tabTitle: '🔊 사운드',
      masterVolume: '마스터 음량',
      seSelect: '효과음 선택',
      sePurin: '🍮 푸링 (기본)',
      sePoyon: '🎈 뽀용 (탄력)',
      seWater: '💧 퐁당 (물방울)',
      mute: '음소거',
    },
    urlModal: {
      title: '웹 이미지 URL에서 로드',
      desc: '웹상의 이미지 URL을 입력하여 캔버스에 직접 불러옵니다.',
      proNote: '(※ 앱 유료 버전 한정 기능)',
      inputLabel: '이미지 URL',
      placeholder: 'https://example.com/image.png',
      samplesTitle: '💡 테스트용 샘플 URL (클릭하여 입력):',
      sampleCat: '🐱 아기 고양이',
      sampleSweet: '🍓 딸기 디저트',
      sampleSakura: '🌸 벚꽃',
      note: '※ 직접 접근 가능한 이미지 URL(JPG, PNG, WebP, SVG 또는 data:image/...)을 지원합니다.',
      submit: '📥 이미지 불러오기',
      loading: '⏳ 로딩 중...',
      cancel: '취소',
      errEmpty: '이미지 URL을 입력해주세요.',
      errInvalid: '유효한 URL(http://, https://, 또는 data:image/...)을 입력해주세요.',
      errFailed: '이미지 로드에 실패했습니다. URL이 올바른지, 또는 교차 출처 접근(CORS)이 허용되어 있는지 확인해주세요.',
    },
    export: {
      title: '애니메이션 및 동영상 내보내기',
      format: '1. 출력 포맷',
      fmtGif: 'GIF 애니메이션',
      fmtMp4: 'MP4 동영상',
      fmtWebm: 'WebM 동영상',
      duration: '2. 녹화 시간',
      start: '🔴 녹화 시작 및 내보내기',
      recording: '⏺ 녹화 중...',
      processing: '⚙️ 인코딩 중...',
      watermarkNotice: '※ Web 무료 버전에서는 워터마크(로고)가 포함됩니다. 앱 유료 버전에서 워터마크 없는 고화질 출력이 가능합니다.',
      cancel: '취소',
      freeNotice: '※ Web 무료 버전은 우측 하단에 귀여운 워터마크가 포함됩니다. SNS 공유를 환영합니다!',
      proNotice: '👑 Pro 버전 활성화: 워터마크 없는 고화질로 저장됩니다.',
      viewProBtn: '👑 Pro 버전 보기',
      completeTitle: '내보내기 완료! 🎉',
      completeSaved: '다운로드가 완료되었습니다! 말랑말랑 애니메이션을 𝕏에 공유해보세요!',
      shareToX: '𝕏 (트위터)로 공유',
      copyShareText: '📋 트윗 내용 복사',
      copiedText: '트윗 내용이 클립보드에 복사되었습니다!',
      downloadAgain: '📥 다시 다운로드',
      tipXShare: '💡 버튼을 누르면 𝕏 작성 창이 열립니다. 방금 다운로드된 동영상/GIF를 𝕏 화면에 끌어다 놓아 첨부하세요!',
      proUpsellTitle: '✨ 워터마크를 제거하고 싶으신가요?',
      proUpsellDesc: 'Pro 버전은 워터마크 완전 제거, 자동 흔들림 및 귀여운 촉각 효과음 지원 ($1.99)',
      newExport: '다시 만들기',
      close: '닫기',
      recTimer: '녹화 중',
      touchHint: '화면을 터치하여 흔들어보세요!',
    },
    preset: {
      saveTitle: '현재 설정을 프리셋으로 저장',
      manageTitle: '프리셋 관리',
      nameLabel: '프리셋 이름',
      saveBtn: '💾 저장',
      applyBtn: '적용',
      deleteBtn: '삭제',
      cancelBtn: '취소',
      defaultName: '푸딩 (기본)',
      maxLimitNotice: '저장 가능한 프리셋 개수가 초과되었습니다.',
    },
    upgrade: {
      title: '앱 버전 (유료) 전용 기능',
      heading: '앱 유료 버전으로 더욱 쾌적하게!',
      perkUrl: '・웹상의 이미지 URL을 직접 지정하여 로드',
      perkPreset: '・무제한 프리셋 저장 및 관리',
      perkExport: '・워터마크 없는 고화질 GIF 및 동영상 내보내기',
      perkAudio: '・터치 시 귀여운 반응 효과음 및 보이스 재생',
      perkWobble: '・살아있는 듯한 자율 자동 흔들림 모드',
      hint: '💡 화면 상단의 시뮬레이터 바에서 "📱 모바일 앱 유료 버전"을 선택하면 지금 바로 모든 기능을 체험할 수 있습니다!',
      ok: '확인 (이해함)',
      buyBtn: '👑 Gumroad에서 Pro 버전 구매하기 (출시 기념 $1.99 / 정가 $2.99)',
      saleBadge: '🔥 출시 기념 33% OFF 세일 진행 중',
      haveKey: '이미 구매하셨나요? 라이선스 키 입력:',
      keyPlaceholder: '라이선스 키 붙여넣기 (예: XXXXXXXX-XXXXXXXX-...)',
      activateBtn: 'Pro 활성화',
      activating: '인증 중...',
      successMsg: '🎉 Pro 버전이 활성화되었습니다! 모든 기능이 해제되었습니다.',
      deactivateBtn: '이 기기의 라이선스 해제',
      deactivatedMsg: '라이선스가 해제되었습니다. 무료 버전으로 전환되었습니다.',
      activeStatus: '👑 Pro 버전 활성화됨',
      errInvalid: '유효하지 않은 라이선스 키입니다. 다시 확인해 주세요.',
      errMaxUses: '이 라이선스의 최대 기기 등록 대수를 초과했습니다.',
      errNetwork: '네트워크 오류가 발생했습니다. 인터넷 연결을 확인해 주세요.',
      errRefunded: '환불되었거나 취소된 라이선스입니다.',
      closeBtn: '닫기',
    },
    share: {
      btnLabel: '𝕏 공유',
      modalTitle: '𝕏 (Twitter)에 공유',
      modalDesc: '말랑말랑 흔들리는 재미있는 경험을 𝕏 (Twitter)에 공유해보세요!',
      tweetText: '「Jiggly Touch」로 이미지를 말랑말랑 흔들어봤어요! 🍮✨ 만져볼 수 있는 이미지를 만들어보세요:',
      hashtags: 'JigglyTouch,지글리터치',
      postBtn: '𝕏에 게시하기',
      copyBtn: '🔗 링크 복사',
      copiedNotice: '링크가 클립보드에 복사되었습니다!',
      exportSuccessTitle: '애니메이션 내보내기 완료! 🎉',
      exportSuccessDesc: '파일이 성공적으로 저장되었습니다. 멋진 흔들림 애니메이션을 𝕏 (Twitter)에 공유해보세요!',
      closeBtn: '닫기',
    },
    ad: {
      sponsored: '스폰서',
      houseAdText: '🍮 Jiggly Touch Pro: 완전 광고 없음 & 모든 기능 잠금 해제 (🔥 33% 할인 $1.99)',
      removeAdsBtn: '👑 광고 제거',
    },
    legal: {
      privacyTitle: '개인정보처리방침',
      termsTitle: '이용약관',
      contactTitle: '문의하기',
      footerPrivacy: '개인정보처리방침',
      footerTerms: '이용약관',
      footerContact: '문의: 𝕏 @KILROYSANWHERE',
      contactDesc: '질문, 버그 제보, 기능 요청은 𝕏 (Twitter) 공식 계정으로 DM 또는 멘션 남겨주세요.',
      xAccount: '@KILROYSANWHERE',
      closeBtn: '닫기',
    },
  },
};
